import Telemetry from '@atlassian/mpac-telemetry';
/**  Tracks fetching & displaying of the search facets (including product, hosting, sort & categories etc) on the home page */

export var DiscoveryFacetsTask = Telemetry.createTask('view-discovery-facets');
/** Tracks the fetching & displaying of the different collections on the home page (including "top selling", "newest", "trending" apps etc) */

export var DiscoveryCollectionsTask = Telemetry.createTask('view-discovery-collections');
/** Tracks fetching and displaying search results */

export var SearchTask = Telemetry.createTask('view-search-results');